import {
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Breadcrumb as ShadcnBreadcrumb,
  BreadcrumbItem as ShadcnBreadcrumbItem,
} from "@/components/ui/breadcrumb";
import { ChevronRight } from "lucide-react";

interface BreadcrumbItemType {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItemType[];
  className?: string;
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <ShadcnBreadcrumb aria-label="パンくずリスト" className={className ?? "mb-6"}>
      <BreadcrumbList className="gap-2 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <span key={item.label} className="flex items-center gap-2">
              {index > 0 && (
                <BreadcrumbSeparator className="[&>svg]:size-4">
                  <ChevronRight
                    data-testid="breadcrumb-separator"
                    className="size-4 text-muted-foreground"
                  />
                </BreadcrumbSeparator>
              )}
              <ShadcnBreadcrumbItem>
                {isLast || !item.href ? (
                  <BreadcrumbPage className="font-bold text-primary">{item.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink href={item.href} className="hover:underline">
                    {item.label}
                  </BreadcrumbLink>
                )}
              </ShadcnBreadcrumbItem>
            </span>
          );
        })}
      </BreadcrumbList>
    </ShadcnBreadcrumb>
  );
}
